import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";
import type { components } from "../schema";

import { TRADES_QUERY_KEY } from "./useTrades";
import { NOTES_QUERY_KEY } from "./useNotes";

type CreateNoteBody = components["schemas"]["CreateNoteBody"];
type NoteResponse = components["schemas"]["NoteResponse"];

export function useCreateNote() {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation<NoteResponse, Error, CreateNoteBody>({
    mutationFn: async (body) => {
      const { data, error } = await client.POST("/api/notes", { body });
      if (error !== undefined) {
        throw new Error("Failed to create note");
      }
      return data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: NOTES_QUERY_KEY });
      // A new note shifts a trade's notes_count, so refresh the trades
      // list to keep the U4b notes-count chip in sync.
      void queryClient.invalidateQueries({ queryKey: TRADES_QUERY_KEY });
    },
  });
}
